
import Code_Reduction from "./Code_Reduction.class";
import AdminService from "@/services/admin.service";

/**
 * @classdesc Liste des codes de réduction
 * @kind class
 * @export
 * @prop {type} prop - Prop desc
 * @class List_Codes_Reduction
 */
export default class List_Codes_Reduction {
    id_module;
    list = [];
    /**
     * Creates an instance of List_Codes_Reduction.
     * @constructs
     * @kind function
     * @memberof List_Codes_Reduction
     */
    constructor(id_module) {
        this.id_module = id_module;
    }

    async fetch() {
        this.list = [];
        let res = await AdminService.fetchCodesReduction(this.id_module);
        if (!res) return false;
        this.set(res);
        return true;
    }

    set(data) {
        for (let i = 0; i < data.length; i++) {
            let code = new Code_Reduction();
            code.set(data[i]);
            this.list.push(code);
        }
    }

    async disable_code(id) {
        for (let i = 0; i < this.list.length; i++) {
            if (this.list[i].id == id) {
                await this.list[i].remove();
                this.list[i].actif = 0;
                return true;
            }
        }
        return false;
    }
    async activate_code(id) {
        for (let i = 0; i < this.list.length; i++) {
            if (this.list[i].id == id) {
                await this.list[i].activate();
                this.list[i].actif = 1;
                return true;
            }
        }
        return false;
    }
    async delete_code(id) {
        for (let i = 0; i < this.list.length; i++) {
            if (this.list[i].id == id) {
                await this.list[i].delete();
                this.list.splice(i, 1);
                return true;
            }
        }
        return false;
    }
}